import React from 'react';
import classNames from 'classnames';
import { QuantityPicker } from 'react-qty-picker';
import {
  Button,
  Container,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';
import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';
import { formatPrice } from '../../../../helpers/commerce';
import WysiwygField from '../../../../components/WysiwygField';
import useProduct from '../../../../hooks/useProduct';

import '../style.scss';

const ParagraphProductGetStarted = ({ entity }) => {
  const {
    quantity,
    setQuantity,
    variationIndex,
    handleOrderClick,
    handleVariationChange,
    isLoading,
    title,
    variationPrice,
    hasMultipleVariations,
    body,
    isAvailable,
  } = useProduct(entity, {
    entityPath: ['field_product', 0, 'entity'],
    trackViewItem: true,
  });

  return (
    <Container className="Paragraph Product ParagraphProduct ParagraphCTA--variant--get-started">
      <div className="row">
        <div className="col-12">
          <div className="ParagraphCTA">
            <div className="ParagraphCTA__inner ParagraphProduct__inner">
              <div className="ParagraphCTA__body ParagraphProduct__body">
                <div className="row">
                  <div className="col-12">
                    <h3 className="ParagraphProduct__title">{title}</h3>
                    <WysiwygField
                      className="ParagraphProduct__description subheading2"
                      property="schema:text"
                      html={body}
                    />
                  </div>
                  <div
                    className={classNames('ParagraphProduct__wrapper col-12', {
                      variant: hasMultipleVariations,
                    })}
                  >
                    <h3 className="Product__Price">
                      &euro; {formatPrice(variationPrice)}{' '}
                      <span>excl. BTW en evt. verzendkosten</span>
                    </h3>
                    {hasMultipleVariations && (
                      <FormikWrapper>
                        <Select
                          required
                          placeholder="Kies een variant"
                          fieldName="product_variation"
                          options=""
                          onChange={handleVariationChange}
                        />
                      </FormikWrapper>
                    )}

                    <div className="Product__orderBar">
                      <QuantityPicker
                        min={1}
                        max={10}
                        value={quantity}
                        onChange={setQuantity}
                        width="2.2rem"
                      />
                      {isAvailable ? (
                        <Button
                          to="#"
                          className="Button--primary Button--order"
                          onClick={handleOrderClick}
                          disabled={isLoading}
                        >
                          Bestellen
                          <div className="icon icon-shopping-cart icon-variant-2" />
                        </Button>
                      ) : (
                        <Button
                          to="#"
                          className="Button--primary Button--order"
                          disabled
                        >
                          Tijdelijk niet bestelbaar
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphProductGetStarted;
